import React from 'react';
import PropTypes from 'prop-types';
import { Container, Row, Col } from 'react-bootstrap';
import cx from 'classnames';
import Button from '../../../../modules/react/components/stateless/Button';
import { categories } from '../../../../src/web/utils/storageCalculator';
import ItemRow from '../../../components/stateful/ItemRow/ItemRow';
import CollapsibleButtons from '../../../components/stateful/CollapsibleButtons';
import SizeSuggestion from '../../../components/stateless/SizeSuggestion/SizeSuggestion';
import classes from './StorageCalculator.scss';
import CurrentPageContext from '../../../contexts/CurrentPageContext';


const propTypes = {
  category: PropTypes.string.isRequired,
  items: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.string.isRequired,
  })),
  counts: PropTypes.shape({
    id: PropTypes.number.isRequired,
  }),
  volume: PropTypes.number.isRequired,
  unitSize: PropTypes.shape({
    id: PropTypes.string.isRequired,
    description: PropTypes.string.isRequired,
    volume: PropTypes.number.isRequired,
  }),
  onChangeCategory: PropTypes.func.isRequired,
  onChangeCount: PropTypes.func.isRequired,
  onResetCounts: PropTypes.func.isRequired,
};
const defaultProps = {
  items: undefined,
  counts: undefined,
  unitSize: undefined,
};

class StorageCalculator extends React.Component {
  static contextType = CurrentPageContext;

  handleCategoryChange = (category) => {
    const { onChangeCategory } = this.props;
    onChangeCategory(category);
  };

  renderRow = (item) => {
    const { counts, onChangeCount } = this.props;

    return (
      <ItemRow
        key={item.id}
        item={item}
        onChange={onChangeCount}
        value={counts[item.id]}
      />
    );
  };

  render() {
    const {
      category, items, unitSize, volume, counts, onResetCounts,
    } = this.props;
    if (!items) {
      return null;
    }

    const { primaryColorClass } = this.context;

    return (
      <Container fluid className={classes.container}>
        <Row>
          <Col sm={12} md={6}>
            <CollapsibleButtons
              options={Object.keys(categories)
                .map(id => ({
                  id,
                  content: categories[id],
                }))}
              onSelect={this.handleCategoryChange}
              selectedOption={category}
              buttonClassName={classes.categoryButton}
            />
            <div className={classes.clearButtonContainer}>
              <Button
                variant="link"
                className={primaryColorClass}
                onClick={onResetCounts}
                disabled={!counts || !Object.keys(counts).length}
              >
                Clear Selections
              </Button>
            </div>
            <div className={classes.rowContainer}>
              {items.map(this.renderRow)}
            </div>
          </Col>
          <Col sm={12} md={6} className={classes.suggestionContainer}>
            <h2
              className={cx(primaryColorClass, classes.suggestionHeading)}
            >
              Size Suggestion
            </h2>
            <SizeSuggestion unitSize={unitSize} volume={volume} />
          </Col>
        </Row>
      </Container>
    );
  }
}

StorageCalculator.propTypes = propTypes;
StorageCalculator.defaultProps = defaultProps;

export default StorageCalculator;
